export const URI: string = "https://graphql.anilist.co";